
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Include Swiper styles
import 'swiper/css/free-mode';



import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { INLINES } from '@contentful/rich-text-types';

gsap.registerPlugin(ScrollTrigger);

export default function PageTraiteur() {
    const [traiteurData, setTraiteurData] = useState(null); // Store the relevant fields

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'traiteur' });

                // console.log(response);

                if (response.items.length > 0) {
                    const { albumPhoto01 = [], nomPage, texte, titre, url } = response.items[0].fields;

                    setTraiteurData({ albumPhoto01, nomPage, texte, titre, url }); // Store only relevant fields
                }
            } catch (error) {
                console.error('Error fetching traiteur data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };



    if (!traiteurData) {
        return null; // Prevents rendering errors while data is loading
    }

    return (
        <section className="section-traiteur" data-content-type="traiteur" id="traiteur" data-background-color='#cccccc'>

            <div className='inner-container'>


                <div className='title'>

                    <p >{traiteurData.nomPage}</p>
                </div>

                {/*    <div className="pictures-container">
                <img src={traiteurData.albumPhoto01[0].fields.file.url} alt='xoxo' />
            </div>
 */}
                <div className="phrase">
                    {documentToReactComponents(traiteurData.titre, renderOptions)}
                </div>

                <div className="mySwiperContainer">

                    <Swiper
                        navigation={true}
                        modules={[Navigation, Keyboard, FreeMode]}
                        loop={true}
                        className="mySwiper"
                        keyboard={true}
                        mousewheel={true}
                        spaceBetween={10}
                        slidesPerView={'auto'}
                        freeMode={false}
                    >
                        {(traiteurData.albumPhoto01 ?? [])

                            .filter(photo => photo.fields?.file?.url) // Only include images with a valid URL
                            .map((photo, photoIndex) => (
                                <SwiperSlide key={photoIndex}>
                                    <img
                                        src={optimizeContentfulImage(photo.fields.file.url)}
                                        alt={`Slide ${photoIndex + 1}`}
                                        width={photo.fields.file.details?.image?.width}
                                        height={photo.fields.file.details?.image?.height}
                                    />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>



                <div className="description">
                    {documentToReactComponents(traiteurData.texte, renderOptions)}
                </div>

                {/*   <div className="mySwiperContainer">

                    <Swiper
                        navigation={true}
                        modules={[Navigation, Keyboard, FreeMode]}
                        loop={true}
                        className="mySwiper"
                        keyboard={true}
                        mousewheel={true}

                        slidesPerView={'auto'}
                        freeMode={true}
                    >
                        {traiteurData.albumPhoto02
                            .filter(photo => photo.fields?.file?.url) // Only include images with a valid URL
                            .map((photo, photoIndex) => (
                                <SwiperSlide key={photoIndex}>
                                    <img 
                                        src={optimizeContentfulImage(photo.fields.file.url)} 
                                        alt={`Slide ${photoIndex + 1}`}
                                        width={photo.fields.file.details?.image?.width}
                                        height={photo.fields.file.details?.image?.height}
                                    />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div> */}

            </div>



        </section>
    );
}
